import { FC } from 'react';
import { useParams, } from 'react-router-dom';

import { useGetCareersMedia, useGetCareersData } from '../../../../hooks/misc';

import DocumentFullPreview from '../../../sub_components/document_preview/DocumentFullPreview';
import Loader from '../../../reusables/Loader';

const CoverLetterFullPreview: FC = () => {
    const { studentId: studentIdParam, coverId: coverIdParam } = useParams();

    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;
    const coverId = coverIdParam ? parseInt(coverIdParam) : 0;

    const { data: careersData } = useGetCareersData(studentId);

    const coverLetterData = careersData?.cover_letters.find((cover_letter) => cover_letter.id === coverId) ?? null;

    // Get the first media ID from the resume data
    const mediaId = coverLetterData?.medias?.[0]?.id;


    const { data: mediaData, isLoading } = useGetCareersMedia(
        studentId ? Number(studentId) : 0,
        mediaId ? Number(mediaId) : 0
    );

    if (!coverLetterData) {
        return <div>Cover Letter not found</div>;
    }

    if (isLoading) {
        return <Loader type="full" text="Loading cover letter..." />;
    }

    // Use media URL if available, otherwise use fallback
    const pdfUrl = mediaData?.url;

    return (
        <DocumentFullPreview
            documentType="cover-letter"
            pdfPath={pdfUrl ?? null}
            backRoute={`/students/${studentId}/cover-letter`}
        />
    );
};

export default CoverLetterFullPreview;